const PALETTE: Array<{ background: string; color: string }> = [
  { background: 'var(--blue-bg, #dbeafe)', color: 'var(--blue, #1d4ed8)' },
  { background: 'var(--purple-bg, #ede9fe)', color: 'var(--purple, #6d28d9)' },
  { background: 'var(--teal-bg, #ccfbf1)', color: 'var(--teal, #0f766e)' },
  { background: 'var(--orange-bg, #ffedd5)', color: 'var(--orange, #c2410c)' },
  { background: 'var(--pink-bg, #fce7f3)', color: 'var(--pink, #be185d)' },
  { background: 'var(--gray-bg, #f1f5f9)', color: 'var(--gray, #475569)' },
];

function hashPalette(module: string): { background: string; color: string } {
  let hash = 0;
  for (let i = 0; i < module.length; i++) {
    hash = (hash * 31 + module.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export default function ModuleChip({ module }: { module?: string | null }) {
  if (!module) return null;
  const { background, color } = hashPalette(module);
  return (
    <span className="badge" style={{ background, color, fontSize: 10.5, fontWeight: 700 }}>
      {module}
    </span>
  );
}
